<template>
<div class="main">
	<div class="banner" ref="case" @click="toBuy">
		<img src="../../images/dadi2026Banner3.png" alt="">
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="产品介绍" name="introduction"></TabPane>
				<TabPane label="其它说明" name="other"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">
			2026雇主责任险（人资方案）<br />
			<!-- <span class="planText">方案编码：CP37020026042402</span> -->
		</div>
		<!-- <div class="center">
			<a v-if="remark" :href="remark" target="_blank">（职业类别表查看）</a>
		</div> -->
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<tbody>
						<tr class="hoverTr">
							<th rowspan="5">基础保障内容</th>
							<th>承保方案</th>
							<th colspan="2">方案1</th>
							<th colspan="2">方案2</th>
							<th>说明</th>
						</tr>
						<tr class="hoverTr">
							<td>身故赔付费用</td>
							<td colspan="2">50万</td>
							<td colspan="2">80万</td>
							<td>在限额内根据用工单位与伤者达成的赔偿金额赔付</td>
						</tr>
						<tr class="hoverTr">
							<td>残疾赔付费用</td>
							<td colspan="2">50万</td>
							<td colspan="2">80万</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>意外医疗费用</td>
							<td colspan="2">10万</td>
							<td colspan="2">20万</td>
							<td>每次事故每人医疗费绝对免赔额200元</td>
						</tr>
						<tr class="hoverTr">
							<td>误工费</td>
							<td colspan="2">100元/人/天</td>
							<td colspan="2">100元/人/天</td>
							<td>免赔3天，限180天，（住院期间160/人/天，非住院期间100元/人/天）</td>
						</tr>
					</tbody>
					<tbody>
						<tr class="hoverTr">
							<th rowspan="7">附加险</th>
							<td>附加超龄人员责任限额减半保险</td>
							<td colspan="2">每人死亡限额25万，每人医疗费用限额5万</td>
							<td colspan="2">每人死亡限额40万，每人医疗费用限额10万</td>
							<td>特定情形下猝死减半（方案1每人猝死死亡限额12.5万，每人医疗费用限额2.5万、方案2每人猝死死亡限额20万，每人医疗费用限额5万）</td>
						</tr>
						<tr class="hoverTr">
							<td>附加高处作业除外保险</td>
							<td colspan="2">同主险</td>
							<td colspan="2">同主险</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加雇员定义保险</td>
							<td colspan="2">同主险</td>
							<td colspan="2">同主险</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加雇员年龄范围保险</td>
							<td colspan="2">同主险</td>
							<td colspan="2">同主险</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加及时报案保险</td>
							<td colspan="2">同主险</td>
							<td colspan="2">同主险</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加特定情形赔偿限额调整保险</td>
							<td colspan="2">每人死亡限额25万，每人医疗费用限额5万</td>
							<td colspan="2">每人死亡限额40万，每人医疗费用限额10万</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加雇员职业类别或工种变更保险</td>
							<td colspan="2">/</td>
							<td colspan="2">/</td>
							<td></td>
						</tr>
					</tbody>
					<tbody>
						<tr class="hoverTr">
							<th rowspan="3">附加险（选投）</th>
							<td>附加伤残等级赔偿责任限额比例调整保险</td>
							<td colspan="2">同主险</td>
							<td colspan="2">同主险</td>
							<td>伤残十级10%选</td>
						</tr>
						<tr class="hoverTr">
							<td>附加员工食堂</td>
							<td colspan="2">每人死亡限额20万，每人医疗费用限额2万</td>
							<td colspan="2">每人死亡限额20万，每人医疗费用限额2万</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<td>附加宿舍责任</td>
							<td colspan="2">每人死亡限额20万，每人医疗费用限额2万</td>
							<td colspan="2">每人死亡限额20万，每人医疗费用限额2万</td>
							<td></td>
						</tr>
					</tbody>
					<tbody>
						<tr>
							<th>保费（元/人/月）</th>
							<th>职业类别</th>
							<th style="width: 100px;">基础保障</th>
							<th>附加食堂、宿舍</th>
							<th style="width: 100px;">基础保障</th>
							<th>附加食堂、宿舍</th>
							<th>备注</th>
						</tr>
					</tbody>
					<tbody>
						<tr class="hoverTr">
							<th rowspan="2">十级10%</th>
							<td>1-3类</td>
							<td>22</td>
							<td>25</td>
							<td>26</td>
							<td>29</td>
							<td rowspan="4" style="text-align: left;">
								1、其中4类占比不超20%<br />
								2、选10%：一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%<br />选5%：一级100%、二级80%、三级70%、四级60%、五级50%、六级40%、七级30%、八级20%、九级10%、十级5%
							</td>
						</tr>
						<tr class="hoverTr">
							<td>4类</td>
							<td>44</td>
							<td>50</td>
							<td>48</td>
							<td>54</td>
						</tr>
						<tr class="hoverTr" ref="introduction">
							<th rowspan="2">十级5%</th>
							<td>1-3类</td>
							<td>21</td>
							<td>24</td>
							<td>25</td>
							<td>28</td>
						</tr>
						<tr class="hoverTr">
							<td>4类</td>
							<td>43</td>
							<td>49</td>
							<td>47</td>
							<td>53</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div>
				<table class="productDetail-table">
					<thead>
						<tr>
							<th>特别约定和条款</th>
						</tr>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td>1.本保单承保的被保险人的雇员仅限与被保险人建立合法劳动或劳务关系的16-70周岁自然人，被保险人与超过法定退休年龄的人员须签订劳务合同或劳动合同（其中，年满65周岁（含）至70周岁（不含）的雇员视为超龄人员，在特定情形下，超龄人员每人猝死死亡责任限额见备注）。如在出险时被保险人实际从事的职业分类等级高于本保单列明承保的职业分类等级的，保险人不承担保险责任且不退还保费。（备注：特定情形下猝死减半（方案1每人猝死死亡限额12.5万，每人医疗费用限额2.5万、方案2每人猝死死亡限额20万，每人医疗费用限额5万））</td>
						</tr>
						<tr class="hoverTr">
							<td>2.本保单的共同被保险人为派遣单位及实际用工单位，详见人员承保明细。</td>
						</tr>
						<tr class="hoverTr">
							<td>3.本保单承保的雇员出险时以承保的人员清单列明的工种、职业类别为准。</td>
						</tr>
						<tr class="hoverTr">
							<td>4.本保单医疗相关保障及误工费赔付限定为中华人民共和国境内合法经营的二级以上（含二级）公立医院或保险公司认可的其他医疗机构，如急诊至二级以下医院（需医保医院）治疗，仅限出险当日1000元以下紧急治疗。</td>
						</tr>
						<tr class="hoverTr">
							<td>5.误工费：每次事故绝对免赔额3天，最高160元/人/天（住院期间160/人/天，非住院期间100元/人/天，具体赔付标准与出险雇员工资两者以低者为准）限180天。</td>
						</tr>
						<tr class="hoverTr">
							<td>6.本保险每次事故每人医疗费绝对免赔额200元；</td>
						</tr>
						<tr class="hoverTr">
							<td>7.雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡且提供尸检报告后确定不是因为既往症引发的死亡的属于保险责任，死亡赔偿限额见备注；无法提供尸检报告的案件以及达到法定退休年龄的人员发生猝死的案件死亡赔偿限额为20万。但因在事故前被保险人的雇员已存在以下症状的：2 级或以上高血压（收缩压≥160mmHg或舒张压≥ 100mmHg），冠心病，心肌病，心梗，风湿性心脏病，心瓣膜病，严重心律失常，心功能不全二级（含）以上；主动脉瘤，主动脉夹层；脑血管病，脑卒中，保险人不负责赔付。被保险人雇员因事故前已患有的疾病、传染病、分娩、堕胎、流产以及因这些疾病而施行内、外科治疗手术所致的伤、残或死亡属于保险人责任免除。（备注：方案1每人猝死死亡限额25万，方案2每人猝死死亡限额40万）</td>
						</tr>
						<tr class="hoverTr">
							<td>8.本方案不承担包含职业病在内的任何疾病和任何性质的精神损害赔偿责任。</td>
						</tr>
						<tr class="hoverTr">
							<td>9.本保单发生损失时员工所在单位与投保时列明的实际用工单位不符，不在赔偿范围内。</td>
						</tr>
						<tr class="hoverTr">
							<td>10.保险事故发生后，被保险人应在出险后48小时内及时报案。法定节假日顺延，积极履行出险后的通知义务，出险后需第一时间报案，对未能第一时间报案的案件，需提供出险时视频监控或能证明事故是在工作期间及工作场所出险的相应监控证明事故发生。出险后超过48小时报案的，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定部分或者因延迟报案导致损失增加部分，保险人不负责赔偿。</td>
						</tr>
						<tr class="hoverTr">
							<td>11.本保单不承保地质矿产业、航运业、渔业、钢结构行业、危险品制造业、建筑工程业、木材加工业、快递业（含外卖人员）、铸造业、锻造业、冶炼业金业、金属轧制业、钢/铁管生产业、道路运输、道路清洁行业的三类职业类别以上人员。   </td>
						</tr>
						<tr class="hoverTr">
							<td>12.本保单被保险人雇员发生属于工伤认定范围内的交通事故，针对死亡赔偿金或伤残赔偿金，保险人按照出险雇员所承担的责任比例设定免赔额：同等责任免赔50%、次要责任和无责任免赔70%，全部责任和主要责任免赔100%。被保险人或雇员有其他保险和其他责任方赔付的保险事故，须先向其他保险和其他责任方进行索赔，保险人仅负责赔偿核定金额内的差额部分。</td>
						</tr>
						<tr class="hoverTr">
							<td>13.附加伤残等级赔偿责任限额比例调整保险，伤残等级对应的赔偿责任限额比例按照《阳光财产保险股份有限公司雇主责任保险附加伤残等级赔偿责任限额比例调整保险（2026版）条款》表1执行，具体为：一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%。（附加伤残等级条款才增加这条）</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="detail-main-text left pt40"><b>产品条款查看：</b></div>
			<div style="font-size: 14px;text-align: left;padding-left: 20px;">
				<p ref="other">
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/%E9%98%B3%E5%85%89%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9B%E6%AC%BE%EF%BC%882026%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险B款（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加高处作业除外保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加高处作业除外保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加雇员职业类别或工种变更保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加雇员职业类别或工种变更保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加超龄人员责任限额减半保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加超龄人员责任限额减半保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加雇员定义保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加雇员定义保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加雇员年龄范围保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加雇员年龄范围保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加特定情形赔偿限额调整保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加特定情形赔偿限额调整保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加及时报案保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加及时报案保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加伤残等级赔偿责任限额比例调整保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加伤残等级赔偿责任限额比例调整保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加宿舍责任保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加宿舍责任保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/阳光财产保险股份有限公司雇主责任保险附加员工食堂保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司雇主责任保险附加员工食堂保险（2026版）条款》</a>
				</p>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">其它说明</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p ref="claim">
					1、新增人员：上半月投保的人员按整月收费，下半月投保的人员按半价收费（具体1-15号投保的都收整月的保费，16-31号投保的都按半价收费）。<br />
					2、承保的投保人、被保险人及实际用工单位仅限于山东地区。<br />
					3、本保单按月承保，人员可批增，不可批退，不可替换，承保单明细上必须体现雇用人员信息。<br />
					4、每单65-70周岁人员保费不变，每家企业投保人数限5%<br />
					5、本方案不承保地质矿产业、航运业、渔业、钢结构行业、危险品制造业、建筑工程业、木材加工业、快递业（含外卖人员）、铸造业、锻造业、冶炼业金业、金属轧制业、钢/铁管生产业、道路运输、道路清洁行业的三类职业类别以上人员。<br />
					6、本方案不承保2米以上高处作业人员。 
				</p>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">理赔流程</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p>
					第一步，报案：发生事故后48小时内，拨打95510电话报案。<br />
					第二步，审核：根据指引提交理赔资料，保险公司将及时进行审核、调查，根据情况通知寄送纸质材料。<br />
					第三步，结案：资料提交齐全后，最晚将在30日内完成审核结案。<br />
					第四步，支付：对属于保险责任且资料齐全的，保险公司将在赔付协议达成后10日内支付赔款。
				</p>
			</div>
		</div>
		<br>
		<br>
	</div>
	<TrackNotice companyName="中国大地财产保险股份有限公司青岛分公司" />
</div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			tabName:'info',
			fixed:false,
			remark:'',
			version:''
		}
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	created(){
		// 获取职业类别表
		this.getJob()
	},
	methods:{
		// 立即购买
		toBuy() {
			// if(this.getTimeState()){
			// 	this.$Modal.warning({
			// 		title: '提示',
            //         content: '今日已超过购买时间，无法购买，请明日再进行购买'
            //     });
			// 	return false
			// }
			//2023.8.7增加回溯逻辑
			this.stopRecord({
				is_new: true
			}).then(()=>{
				this.$router.push(`/companyGroupEmployerDadi/fillin?productCode=SUNLIGHT_EMPLOYER_LIABILITY&productName=阳光人资雇主责任险方案&version=${this.version}`)
			})
		},
		getTimeState(){
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 设置默认文字
			let state= false;
			// 判断当前时间段
			if (hours > 21 && hours <= 24) {
				state= true;
			}
			return state;
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		},
		async getJob(){
			await this.$axios.post('/broker/dict/find.json',{
				bizId:'INDUSTRY_ENTERPRISE',
				companyId: '10157',
				dictCode:'work_type',
				productCode: 'SUNLIGHT_EMPLOYER_LIABILITY',
			}).then((res) => {
				this.remark = res.remark;
				this.version = res.version;
			})
		}
	}
}
</script>
<style scoped lang="less">
	.planText{
		color: #666;
		font-size: 16px !important;
	}
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 24px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }
	.productDetail-table{
		font-size: 14px !important;
		th{
			font-size: 16px !important;
			text-align: center;
			padding: 10px;
		}
	}
    .productDetail-table .sm {
        font-size: 13px;
        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/indexCCIC_M5.vue